import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import Typography from '@material-ui/core/Typography';

import SchoolIcon from '@material-ui/icons/School';
import WorkIcon from '@material-ui/icons/Work';
const useStyles = makeStyles((theme) => ({
  panel: {
    marginTop: 50,
  },
}));

export default function CareerLine() {
  const classes = useStyles();

  return (
    <Timeline align="alternate" className={classes.panel}>
      <TimelineItem>
        <TimelineOppositeContent>
          <Typography variant="body2" color="textSecondary">
            2009 - 2013
          </Typography>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot  color="primary">
            <SchoolIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
            <Typography>
              <b>University of Science and Technology of China</b>
            </Typography>
            <Typography>
							<b>B.S.</b> in Geophysics
            </Typography>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem>
        <TimelineOppositeContent>
          <Typography variant="body2" color="textSecondary">
            2013 - 2016
          </Typography>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot color="primary">
            <SchoolIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
            <Typography>
							<b>University of Chinese Academy of Sciences</b>
            </Typography>
            <Typography>
							<b>M.S.</b> in Geophysics
            </Typography>
        </TimelineContent>
      </TimelineItem>
			<TimelineItem>
        <TimelineOppositeContent>
          <Typography variant="body2" color="textSecondary">
            2016 - 2018
          </Typography>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot color="primary">
            <SchoolIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
            <Typography>
							<b>University of Oklahoma</b>
            </Typography>
            <Typography>
							<b>M.S.</b> in Geophysics
            </Typography>
        </TimelineContent>
      </TimelineItem>
			<TimelineItem>
        <TimelineOppositeContent>
          <Typography variant="body2" color="textSecondary">
            2018 - 2019
          </Typography>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot color="secondary">
            <WorkIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
            <Typography>
							<b>MokaHR</b>
            </Typography>
            <Typography>
							Full Stack Web Developer
            </Typography>
        </TimelineContent>
      </TimelineItem>
			<TimelineItem>
        <TimelineOppositeContent>
          <Typography variant="body2" color="textSecondary">
            2020 Summer
          </Typography>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot color="secondary">
            <WorkIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
            <Typography>
							<b>IMVU</b>
            </Typography>
            <Typography>
							Software Engineer Intern
            </Typography>
        </TimelineContent>
      </TimelineItem>
			<TimelineItem>
        <TimelineOppositeContent>
          <Typography variant="body2" color="textSecondary">
            2019 - 2021
          </Typography>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot color="primary">
            <SchoolIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
            <Typography>
							<b>University of Southern California</b>
            </Typography>
            <Typography>
							<b>M.S.</b> in Analytics
            </Typography>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem>
        <TimelineOppositeContent>
          <Typography variant="body2" color="textSecondary">
            2021 - present
          </Typography>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot color="secondary">
            <WorkIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
            <Typography>
							<b>Google</b>
            </Typography>
            <Typography>
							Software Engineer
            </Typography>
        </TimelineContent>
      </TimelineItem>
    </Timeline>
  );
}
